
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useReagentsQuery } from "@/hooks/useReagentsQuery";
import { useReagentFilters } from "@/hooks/useReagentFilters";
import ReagentFilters from "@/components/reagents/ReagentFilters";
import ReagentList from "@/components/reagents/ReagentList";
import ReagentPageHeader from "@/components/reagents/ReagentPageHeader";
import ErrorBanner from "@/components/reagents/ErrorBanner";

const ReagentsPage = () => {
  // Fetch and manage reagents data
  const { 
    reagents, 
    categories, 
    isLoading, 
    error, 
    isError,
    refetch, 
    isRetrying 
  } = useReagentsQuery();

  // Manage filters and filtered data
  const {
    searchTerm,
    setSearchTerm,
    selectedCategory,
    setSelectedCategory,
    selectedLocation,
    setSelectedLocation,
    showFilters,
    setShowFilters,
    filteredReagents,
    locations,
    resetFilters
  } = useReagentFilters({ reagents });

  console.log("ReagentsPage - reagents:", reagents.length, 
    "filtered:", filteredReagents.length, 
    "isLoading:", isLoading);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="container mx-auto px-4 py-8 flex-grow">
        <ReagentPageHeader 
          showFilters={showFilters}
          toggleFilters={() => setShowFilters(!showFilters)}
          handleRefresh={refetch}
          isRetrying={isRetrying}
        />
        
        <ErrorBanner error={error} visible={isError} />
        
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          <ReagentFilters 
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectedLocation={selectedLocation}
            setSelectedLocation={setSelectedLocation}
            categories={categories}
            locations={locations}
            resetFilters={resetFilters}
            showFilters={showFilters}
            toggleFilters={() => setShowFilters(!showFilters)}
          />
          
          <ReagentList 
            reagents={filteredReagents}
            isLoading={isLoading}
            error={error}
            refetch={refetch}
            resetFilters={resetFilters}
          />
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default ReagentsPage;
